exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".StaticItem{background:#f3f3f3;margin-bottom:10px;border:1px solid #ddd;padding:10px;width:100%;cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./yii2/frontend/frontend-assets/src/components/StatisticReports/QuizAnswers/style.scss
// module id = 5041
// module chunks = 0